import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LogoutButton from '@/components/auth/LogoutButton'
import Icon from '@/components/Icon'
import { localized } from '@/decorators/localized'
import classNames from 'classnames'
import { BackgroundJobMenuItem } from '@/components/backgroundJobs/backgroundJobMenuItem'
import GoToBackgroundJobsLink from '@/components/backgroundJobs/goToBackgroundJobsLink'

import {
  Navbar,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap'
import { MainMenu } from '@/components/Layout/MainMenu'
import Resx from '@/components/Resx'
import { dialogTypes } from '@/dialogs'
import { openDialog } from '@/store/Dialogs'
import { Name } from '@/components/Name'
import { NotificationWidget } from '@/components/notifications/widget'

@localized()
class Menu extends React.Component {
  changeInstitutionClick = e => {
    e.preventDefault()
    this.props.openDialog({ dialogType: dialogTypes.institutionSelection })
  }

  render () {
    const { name, InstitutionName, InstitutionLatinName, InstitutionSelection } = this.props.profile
    return (
      <React.Fragment>
        <Navbar dark expand className={classNames({ 'navbar--small': this.props.isNavSmall })}>
          <Link className='header__logo' to='/'><Resx name='Common.ReportApp' /></Link>
          <UncontrolledDropdown className='dropdown--profile'>
            <DropdownToggle nav className='nav-link--top'>
              <Icon name='user-circle' />
            </DropdownToggle>
            <DropdownMenu className=''>
              <h6 className='dropdown-header'>{name}</h6>
              <div className='dropdown-item'>
                <Link to='/user-profile'><Icon name='bxs-user-detail' /> <Resx name='Common.ShowProfile' /></Link>
              </div>
              <div className='dropdown-item'>
                <Link to='/dashboard-settings'><Icon name='bxs-dashboard' /> <Resx name='Common.DashboardWidgets' /></Link>
              </div>
              {!!InstitutionSelection &&
              <div className='dropdown-item'>
                <Link onClick={this.changeInstitutionClick} to={'/'}>
                  <Icon name='building' />  <Resx name='Institutions.ChangeInstitution' />
                </Link>
              </div>}
              <div className='dropdown-divider' />
              <DropdownItem>
                <GoToBackgroundJobsLink showIcon />
              </DropdownItem>
              <LogoutButton Component={DropdownItem} />
            </DropdownMenu>
          </UncontrolledDropdown>
          <NotificationWidget />
          <BackgroundJobMenuItem />
          <Collapse navbar>
            <MainMenu topItems={[{ id: 'institution',
              icon: 'building',
              text: () => <Name data={{ name: InstitutionName, latinName: InstitutionLatinName }} />,
              path: '/demographics/institution-detail',
              className: 'institution-nav-item'
            }]} />
          </Collapse>
        </Navbar>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    profile: state.identity.user.profile,
    isNavSmall: state.menu.isNavSmall,
    ...ownProps
  }
}

export default connect(mapStateToProps, { openDialog })(Menu)



// WEBPACK FOOTER //
// ./src/report-app/menu.js